import { render, staticRenderFns } from "./NumberOfIllnessesByRank.vue?vue&type=template&id=0fa0f7c4&scoped=true&"
import script from "./NumberOfIllnessesByRank.vue?vue&type=script&lang=js&"
export * from "./NumberOfIllnessesByRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0f7c4",
  null
  
)

export default component.exports